import { useMutation } from "@apollo/client";
import Button from "components/Button";
import Page from "components/Page";
import Text from "components/Text";
import { useState } from "react";
import { toast } from "react-toastify";
import { SUBMIT_FEEDBACK } from "./graphql";

const Support = () => {
  const [message, setMessage] = useState("");
  const [submitFeedback, submitFeedbackRes] = useMutation(SUBMIT_FEEDBACK, {
    onCompleted() {
      toast.success("Submit Success. 提交成功, 我们会尽快处理您的请求!");
      setMessage("");
    },
    onError(error) {
      toast.error(error.message);
    },
  });

  function submit() {
    if (message === "") {
      toast.error("Please input the message. 请输入内容");
      return;
    }
    submitFeedback({ variables: { message, subject: "Supplier feedback" } });
  }
  return (
    <Page title="Support 支持与反馈">
      <div className="flex-1 flex justify-center xl:items-center">
        <div className="p-8 container max-w-3xl text-center xl:-mt-20">
          <h2>We are happy to hear from you! </h2>
          <h3>我们很高兴听到您的反馈！</h3>
          <div className="opacity-70 mt-4 space-y-2">
            <p>
              我们非常重视您的反馈和建议，因为它们帮助我们不断改进和提供更好的服务。无论您是遇到了问题、对我们的产品有任何建议，还是想分享您的使用体验，我们都欢迎您在这里留言。
            </p>
            <p>感谢您花时间与我们分享您的想法！</p>
          </div>
          <div className="mt-6">
            <Text
              className=" placeholder:text-center"
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Input your feedback here 请在这里写下你的想法..."
            />
          </div>
          <div className="flex justify-center p-4">
            <Button loading={submitFeedbackRes.loading} onClick={submit} send>
              Submit 提交
            </Button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Support;
